import { BaseRepository } from './base-repository';
import type {
  FieldTicketResponse,
  FieldTicketRequest,
  CreateTicketResponse,
  UpdateTicketRequest,
  DeleteDefectLineRequest,
} from '@core/types/ticket';

export class TicketAPI extends BaseRepository {
  private readonly baseEndpoint = '/api/method/field-ticket';
  private readonly defectLineEndpoint = '/api/method/defect-line';

  /**
   * GET /api/method/field-ticket?ticket_id_external=xxx
   * Retrieves ticket detail by external ID (query param, NOT URL param).
   */
  async getByExternalId(externalId: string): Promise<FieldTicketResponse> {
    return this.getAll<FieldTicketResponse>(
      this.baseEndpoint,
      { ticket_id_external: externalId }
    );
  }

  /**
   * POST /api/method/field-ticket
   * Creates a new field quality ticket.
   */
  async createTicket(data: FieldTicketRequest): Promise<CreateTicketResponse> {
    return this.create<CreateTicketResponse, FieldTicketRequest>(
      this.baseEndpoint,
      data
    );
  }

  /**
   * PUT /api/method/field-ticket
   * Updates an existing ticket and/or adds/modifies defect lines.
   * The ticket_id_external is sent in the request body.
   */
  async updateTicket(data: UpdateTicketRequest): Promise<FieldTicketResponse> {
    return this.updateWithBody<FieldTicketResponse, UpdateTicketRequest>(
      this.baseEndpoint,
      data
    );
  }

  /**
   * DELETE /api/method/defect-line
   * Deletes a specific defect line from a ticket.
   * Uses JSON body with ticket_id_external and defect_line_id.
   */
  async deleteDefectLine(ticketIdExternal: string, defectLineId: string): Promise<void> {
    await this.deleteWithBody<DeleteDefectLineRequest>(
      this.defectLineEndpoint,
      { ticket_id_external: ticketIdExternal, defect_line_id: defectLineId }
    );
  }
}
